(() => {
  const root = document.querySelector('[data-mc-np]');
  if (!root) return;

  const KEY = 'mc-np-seen';
  const days = parseInt(root.getAttribute('data-frequency'), 10) || 7;
  const trigger = root.getAttribute('data-trigger') || 'delay';
  const delay = (parseFloat(root.getAttribute('data-delay')) || 5) * 1000;
  const design =
    document.documentElement.classList.contains('shopify-design-mode') ||
    (window.Shopify && window.Shopify.designMode);
  const forcePreview = root.getAttribute('data-force-preview') === 'true';

  const seen = () => {
    try {
      const t = parseInt(localStorage.getItem(KEY), 10);
      return t && Date.now() < t;
    } catch (e) {
      return false;
    }
  };
  const remember = (d) => {
    try {
      localStorage.setItem(KEY, String(Date.now() + d * 864e5));
    } catch (e) {}
  };

  const SUB = 'mc-np-sub';
  const subscribed = () => {
    try {
      return localStorage.getItem(SUB) === '1';
    } catch (e) {
      return false;
    }
  };
  const TABX = 'mc-np-tab-dismiss';
  const tabDismissed = () => {
    try {
      return localStorage.getItem(TABX) === '1';
    } catch (e) {
      return false;
    }
  };
  const tab = document.querySelector('[data-mc-np-tab-wrap]');
  const tabOpen = document.querySelector('[data-mc-np-tab]');
  const tabX = document.querySelector('[data-mc-np-tab-dismiss]');
  const showTab = () => {
    if (tab && !subscribed() && !tabDismissed()) tab.classList.add('is--show');
  };
  const hideTab = () => {
    if (tab) tab.classList.remove('is--show');
  };

  if (tabX)
    tabX.addEventListener('click', (e) => {
      e.stopPropagation();
      hideTab();
      try {
        localStorage.setItem(TABX, '1');
      } catch (e2) {}
    });

  let opened = false,
    lastFocus = null;

  function open(viaTab) {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    hideTab();
    document.body.classList.add('mc-np-open');
    root.classList.toggle('is--via-tab', !!viaTab);
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is--open'));
    document.addEventListener('keydown', onKey);
    remember(days);
  }
  function close() {
    opened = false;
    root.classList.remove('is--open');
    document.removeEventListener('keydown', onKey);
    document.body.classList.remove('mc-np-open');
    setTimeout(() => {
      root.hidden = true;
    }, 360);
    showTab();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
  }
  root.querySelectorAll('[data-mc-np-close]').forEach((el) => el.addEventListener('click', close));

  const intro = root.querySelector('[data-mc-np-intro]');
  const formView = root.querySelector('[data-mc-np-form-view]');
  const successView = root.querySelector('[data-mc-np-success]');
  const yes = root.querySelector('[data-mc-np-yes]');
  if (yes)
    yes.addEventListener('click', () => {
      if (intro) intro.hidden = true;
      if (formView) {
        formView.hidden = false;
        root.querySelector('[data-mc-np-email]')?.focus();
      }
    });

  const form = root.querySelector('[data-mc-np-form]');
  const endpoint = (root.getAttribute('data-endpoint') || '').trim();
  const shopifySync = root.getAttribute('data-shopify-sync') !== 'false';
  const phoneRequired = root.getAttribute('data-phone-required') === 'true';
  const smsDisclosure = root.getAttribute('data-sms-disclosure') === 'true';
  const errEl = root.querySelector('[data-mc-np-error]');
  const submitBtn = root.querySelector('[data-mc-np-submit]');
  const emailEl = root.querySelector('[data-mc-np-email]');
  const phoneEl = root.querySelector('[data-mc-np-phone]');
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const validPhone = (v) => {
    const d = v.replace(/\D/g, '');
    if (v.trim().startsWith('+')) return d.length >= 8 && d.length <= 15;
    return d.length === 10 || (d.length === 11 && d[0] === '1');
  };

  function showError(msg, field) {
    if (errEl) {
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    [emailEl, phoneEl].forEach((el) => el && el.removeAttribute('aria-invalid'));
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    }
  }
  function clearError() {
    if (errEl) {
      errEl.textContent = '';
      errEl.hidden = true;
    }
    [emailEl, phoneEl].forEach((el) => el && el.removeAttribute('aria-invalid'));
  }
  function showSuccess() {
    if (formView && successView) {
      formView.hidden = true;
      successView.hidden = false;
    }
    remember(3650);
    try {
      localStorage.setItem(SUB, '1');
    } catch (e) {}
  }

  function shopifyPost(email) {
    const fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '\u2713');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter,email_popup');
    const root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root_url + 'contact', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin',
    }).catch(() => {});
  }

  if (form)
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearError();

      const hp = form.querySelector('[name="company"]');
      if (hp && hp.value) {
        showSuccess();
        return;
      }

      const email = emailEl ? emailEl.value.trim() : '';
      const phone = phoneEl ? phoneEl.value.trim() : '';

      if (!EMAIL_RE.test(email)) return showError('Please enter a valid email address.', emailEl);
      if (phoneEl && phoneRequired && !phone)
        return showError('Please enter your phone number.', phoneEl);
      if (phone && !validPhone(phone))
        return showError('Please enter a valid US phone number (10 digits).', phoneEl);

      if (!endpoint) {
        shopifyPost(email);
        showSuccess();
        return;
      }

      const label = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
      }

      try {
        const r = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            phone,
            sms_consent: !!phone && smsDisclosure,
            phone_required: phoneRequired,
            page_url: location.href,
            offer: root.getAttribute('data-offer') || '',
            presentation: root.classList.contains('is--via-tab') ? 'tab' : 'takeover',
            company: hp ? hp.value : '',
          }),
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok || !data.ok) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = label;
          }
          if (data.field === 'email')
            return showError('Please enter a valid email address.', emailEl);
          if (data.field === 'phone')
            return showError('Please enter a valid US phone number (10 digits).', phoneEl);
          return showError('Something went wrong. Please try again.');
        }
      } catch (err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = label;
        }
        return showError('Connection problem. Please try again.');
      }

      if (shopifySync) shopifyPost(email);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = label;
      }
      showSuccess();
    });

  if (tabOpen) tabOpen.addEventListener('click', () => open(true));

  const codeBtn = root.querySelector('[data-mc-np-code]');
  if (codeBtn)
    codeBtn.addEventListener('click', () => {
      const code = codeBtn.getAttribute('data-code');
      (navigator.clipboard && navigator.clipboard.writeText
        ? navigator.clipboard.writeText(code)
        : Promise.resolve()
      ).catch(() => {});
      codeBtn.classList.add('is--copied');
      setTimeout(() => codeBtn.classList.remove('is--copied'), 1500);
    });

  if (design) {
    const step = root.getAttribute('data-editor-step');
    if (step === 'tab') {
      root.classList.remove('is--open');
      root.hidden = true;
      if (tab) {
        tab.hidden = false;
        tab.classList.add('is--show');
      }
      return;
    }
    open(false);
    if (step === 'form') {
      if (intro) intro.hidden = true;
      if (formView) formView.hidden = false;
    } else if (step === 'success') {
      if (intro) intro.hidden = true;
      if (formView) formView.hidden = true;
      if (successView) successView.hidden = false;
    }
    return;
  }

  if (!forcePreview) {
    if (subscribed()) return;
    if (seen()) {
      showTab();
      return;
    }
  }
  if (trigger === 'exit') {
    document.addEventListener('mouseout', function onExit(e) {
      if (e.clientY <= 0 && !e.relatedTarget) {
        open(false);
        document.removeEventListener('mouseout', onExit);
      }
    });
    setTimeout(() => open(false), 45000);
  } else if (trigger === 'scroll') {
    const onScroll = () => {
      if ((window.scrollY + window.innerHeight) / document.body.scrollHeight > 0.4) {
        open(false);
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  } else {
    setTimeout(() => open(false), delay);
  }
})();
